(function () {
    'use strict';
    var m = angular.module('gui-v2');
    m.controller('DashboardControllerV2', ["$scope", "$q", "wizardHelper", "modulesManager", "routeHelper", "widgetSettings", "modulesDao", "configDao", "feature", "modals", "http", function ($scope, $q, wizardHelper, modulesManager, routeHelper, widgetSettings, modulesDao, configDao, feature, modals, http) {
        $scope.loadedModules = false;
        var resolutionUuid = '45207ade-d026-4eba-bca6-1363be329764';
        $scope.model = { resolution: widgetSettings.param(resolutionUuid, 'resolution') || 'month' };
        configDao.param('hide_dashboard_widgets').then(function (value) {
            $scope.model.hideDashboardWidgets = value;
        });
        // group filter popup check
        var selectGroupsStage = window.localStorage.getItem('selectGroupsStage');
        if (selectGroupsStage) {
            modulesDao.displayUserGroupsFilterModal(selectGroupsStage);
        }
        // TODO: Remove this code after all customers have moved to the new apps.
        if (feature.office365ReauthPopup && !selectGroupsStage) {
            checkOffice365ReAuth();
        }
        function checkOffice365ReAuth() {
            // We want to display it only once a day
            if (!feature.sonicwallTheme && !feature.checkpointTheme && localStorage.getItem('office365ReAuth_lastPopupDay') != new Date().getDate()) {
                http.get('/api/v1/apps/display_office365_emails_re_auth').then(function (response) {
                    if (response.data) {
                        localStorage.setItem('office365ReAuth_lastPopupDay', new Date().getDate());
                        displayOffice365ReAuth();
                    }
                });
            }
        }
        function displayOffice365ReAuth() {
            return modals.params([{
                    lastPage: true,
                    hideDefaultButton: true,
                    okButton: 'Authorize',
                    label: 'Office 365 API Update: Authorization Required',
                    params: [
                        {
                            type: 'message',
                            message: 'We recently added support for Office 365\'s newest API, ' + boldify('Microsoft Graph') + ', and renovated the OneDrive / SharePoint integration using the latest capabilities. In a few months, the older API will deprecate and this update will become mandatory. '
                        },
                        {
                            type: 'message',
                            message: '#' + JSON.stringify({
                                display: 'external-link',
                                href: 'https://developer.microsoft.com/en-us/office/blogs/outlook-rest-api-v1-0-office-365-discovery-and-live-connect-api-deprecation/',
                                text: 'Learn more'
                            })
                        },
                        {
                            type: 'message',
                            message: 'Please click on the ' + boldify('Authorize') + ' button and authorize our Office 365 Apps with a Global Admin Account to grant Avanan access to the Microsoft graph APIs.'
                        }
                    ]
                }], 'Office 365 API Update: Authorization Required').then(function (data) {
                localStorage.setItem('trigger_office365_emails_reauthorize', true);
                routeHelper.redirectTo('cloud-apps');
            });
        }
        /////
        function boldify(str) {
            return '#' + JSON.stringify({
                display: 'text',
                'class': 'bold-text',
                text: str
            });
        }
        $scope.$watch('model.resolution', function (newValue) {
            widgetSettings.param(resolutionUuid, 'resolution', newValue);
        });
        modulesManager.init().then(function () {
            $scope.loadedModules = true;
            wizardHelper.reloadState().then(function () {
                var saasAppsLength = modulesManager.activeSaasApps().length || 0;
                var wizardState = wizardHelper.getState().inProgress || false;
                if (saasAppsLength === 0 || wizardState) {
                    routeHelper.redirectTo('wizard');
                }
            });
        });
    }]);
}());